// User Groups translations for React Admin resource
export const userGroupsResource = {
  name: 'User Group |||| User Groups',
  fields: {
    id: 'ID',
    name: 'Name',
    description: 'Description',
    memberCount: 'Members',
    createdAt: 'Created',
    updatedAt: 'Updated',
    createdBy: 'Created By',
    updatedBy: 'Updated By',
    userId: 'User',
    addedAt: 'Added At',
  },
};

// Custom user-groups translations for components
export const userGroups = {
  subtitle: 'Manage user groups used as reservation eligibility primitives',
  sections: {
    basic: 'Basic Information',
    members: 'Members',
    audit: 'Audit Trail',
  },
  list: {
    title: 'User Groups',
    subtitle: 'Manage user groups',
    searchPlaceholder: 'Search by name or description',
    noGroups: 'No user groups defined yet',
    filters: {
      search: 'Search',
    },
  },
  create: {
    title: 'Create User Group',
    subtitle: 'Define a new user group for reservation eligibility',
    backToList: 'Back to user groups',
  },
  edit: {
    title: 'Edit User Group',
    subtitle: 'Modify group details and membership',
    backToList: 'Back to user groups',
  },
  show: {
    subtitle: 'User group details',
    tabs: {
      details: 'Details',
      members: 'Members',
    },
  },
  members: {
    title: 'Group Members',
    add: 'Add Member',
    add_app_user: 'Add App User',
    add_rfid_user: 'Add RFID User',
    remove: 'Remove',
    searchUsers: 'Search users by email, phone, or numeric ID',
    searchRfidUsers: 'Search RFID users by name, email, or phone',
    selectUser: 'Select user to add',
    selectRfidUser: 'Select RFID user to add',
    confirmRemove: 'Remove this user from the group?',
    empty: 'No members in this group',
    addedSuccess: 'Member added to group',
    removedSuccess: 'Member removed from group',
    duplicate: 'This user is already a member of the group',
    memberType: 'Type',
    type: {
      app_user: 'App User',
      rfid_user: 'RFID User',
    },
  },
  validation: {
    nameRequired: 'Name is required',
    nameTooLong: 'Name must be 100 characters or fewer',
    descriptionTooLong: 'Description must be 500 characters or fewer',
  },
  helpers: {
    name: 'Choose a descriptive name (e.g., "VIP Customers", "Beta Testers")',
    description: 'Describe the purpose of this group',
  },
  notifications: {
    created: 'User group created successfully',
    updated: 'User group updated successfully',
    deleted: 'User group deleted successfully',
    error: {
      create: 'Failed to create user group',
      update: 'Failed to update user group',
      delete: 'Failed to delete user group',
    },
  },
  actions: {
    create: 'Create User Group',
    save: 'Save Changes',
    delete: 'Delete Group',
    addMember: 'Add Member',
  },
};

export const userGroupsTranslations = {
  'user-groups': {
    ...userGroupsResource,
    ...userGroups,
  },
};
